<template>
    <form-dialog :value="value" @input="$emit('input', $event)" #default="{ close }">
        <delete-annotation-card
            :loading="$wait.is('deleteAnnotation')"
            :value="annotation"
            :title="$t('deleteAnnotationDialog.deleteAnnotationTitle')"
            :subtitle="$t('deleteAnnotationDialog.deleteAnnotationSubtitle')"
            :simple="true"
        >
            <template #actions="{ isValid, formId, loading }">
                <back-button @click="close()"></back-button>
                <v-spacer></v-spacer>
                <delete-annotation-button
                    :annotationId="annotation.id"
                    :valid="isValid"
                    :loading="loading"
                    :form="formId"
                    v-wait-while="'deleteAnnotation'"
                    @http2xx="close().then(() => handleDeleteSuccess($event))"
                />
            </template>
        </delete-annotation-card>
    </form-dialog>
</template>

<i18n>
{
    "en": {
        "deleteAnnotationDialog.deleteAnnotationTitle": "Delete Annotation",
        "deleteAnnotationDialog.deleteAnnotationSubtitle": "This action is not reversable, you will need to add a new annotation.",
        "deleteAnnotationDialog.successfulDelete": "Annotation successfully deleted."
    }
}
</i18n>

<script>
import DeleteAnnotationCard from '@/components/Common/DeleteEntityCard.vue';
import DeleteAnnotationButton from '@/components/Domain.Annotations/DeleteAnnotationButton.vue';
import { toastSuccess } from '@/components/Common/Toast.vue';
export default {
    components: { DeleteAnnotationCard, DeleteAnnotationButton },
    props: {
        value: Boolean,
        annotation: Object,
    },
    methods: {
        handleDeleteSuccess(result) {
            toastSuccess(this.$t('deleteAnnotationDialog.successfulDelete'));
            this.$emit('http2xx', result);
        },
    },
};
</script>